module.exports = __webpack_public_path__ + "static/ant-financial-f09d85218f3f89edfdab0efa01f28c02.png";